import PriceContainer from '@nespresso/catalog-components-react/containers/PriceContainer';
import useMarketConfig from '@/widgets/hooks/useMarketConfig.tsx';
import useRoute from '@/widgets/hooks/useRoute.tsx';
import { strikethroughPriceFromProductDiscount } from '@/domain/Product.ts';
import type { Product } from '@/domain/Product';
import styles from './Header.module.scss';
import usePriceFormatter from '@/widgets/hooks/usePriceFormatter';

type HeaderProps = {
  product: Product | undefined;
  title?: string;
  offerText?: string;
};
export default function Header({ title, product, offerText }: HeaderProps) {
  const formatPrice = usePriceFormatter();
  const { locale } = useRoute();
  const {
    financialSettings: { defaultCurrency: currencyCode }
  } = useMarketConfig();

  return (
    <div>
      <div class={styles.titlePriceRow}>
        {title ? <h3 class={styles.title}>{title}</h3> : <div />}
        {product && !product.isSubscriptionOnly && (
          <PriceContainer
            locale={locale}
            currencyCode={currencyCode}
            price={product.pricing.price}
            strikethroughPrice={
              product.discount
                ? strikethroughPriceFromProductDiscount(
                    product.pricing.price,
                    product.discount
                  )
                : undefined
            }
            layoutMode="row"
            layoutOrder="price-first"
            priceFormatter={(v) => formatPrice(v)}
          />
        )}
      </div>
      {!!offerText && (
        <div class={styles.offerInfoRow}>
          <span class={styles.offerInfo}>{offerText}</span>
        </div>
      )}
    </div>
  );
}
